
export function mainOrgData
    (state = {}, action: any) {
    switch (action.type) {
        case 'MAIN_ORG_DATA':
            return action.data;
        default:
            return state;
    }
}